import { buildRelevanceSortCriterion } from './sort.js';
export function getCommerceSortInitialState() {
    return {
        appliedSort: buildRelevanceSortCriterion(),
        availableSorts: [buildRelevanceSortCriterion()],
    };
}
